import { Theme } from "@mui/material";

export const TitleSizeStyles = (theme: Theme) => {
    return {
        sm: {
            fontSize: theme.fontSizes["xl"],
        },
        md: {
            fontSize: theme.fontSizes["2xl"],
        }
    };
};


export const SubTitleSizeStyles = (theme: Theme) => {
    return {
        sm: {
            fontSize: theme.fontSizes.md,
        },
        md: {
            fontSize: theme.fontSizes.lg,
        }
    };
};